export enum MenuItemsEnum {
  PROJECT = 'PROJECT',
  LANGUAGE = 'LANGUAGE',
  JOB = 'JOB',
}
